export default {
      id: "status_move-usage",
      viewBox: "0 0 26 27",
      url: __webpack_public_path__ + "img/icons.svg#status_move",
      toString: function () {
        return this.url;
      }
    }